(function(e){"use strict";e.fn.markbox=function(e) {
	$(this).click(function(t) {
		console.log($(this).data())
		var getLink = $(this).attr('href')
		if(getLink.indexOf('youtube') > -1) {
			
			var vidID = 'https://www.youtube.com/embed/' + getLink.split('=')[1]
			$('body').prepend('<div class="markbox"><iframe src="' + vidID + '?autoplay=1" frameborder="0" allowfullscreen></iframe></div>')
			
			var getHeight = $('.markbox iframe').width() * 315/560
			$('.markbox iframe').height(getHeight)
			
			$('.markbox').click(function() {
				$(this).remove()
			})

			$(window).resize(function () {
	    		waitForFinalEvent(function(){
	      			var getHeight = $('.markbox iframe').width() * 315/560
					$('.markbox iframe').height(getHeight)
			    }, 500, "some unique string");
			});
		}
		t.preventDefault()
	})
	var waitForFinalEvent = (function () {
	  var timers = {};
	  return function (callback, ms, uniqueId) {
	    if (!uniqueId) {
	      uniqueId = "Don't call this twice without a uniqueId";
	    }
	    if (timers[uniqueId]) {
	      clearTimeout (timers[uniqueId]);
	    }
	    timers[uniqueId] = setTimeout(callback, ms);
	  };
	})();
}})(jQuery)